// extracted by mini-css-extract-plugin
export default {"tcFooter":"talent-calculator-footer_tcFooter__Mh7Yz","reset":"talent-calculator-footer_reset__sah2j","share":"talent-calculator-footer_share__ZrGbW"};